import { Drawer, message, Tabs } from 'antd';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { useEffect, useState } from 'react';
import { SegmentsService } from 'services/SegmentsService';
import { ClientsForm } from './ClientForm';
import { GeneralForm } from './GeneralForm';

function SegmentsForm({ initialValues, isActive, onClose, onSuccess }) {
  const isEditing = initialValues !== null;
  const [activeTab, setActiveTab] = useState('general');
  const hiddenTab = initialValues?.type;

  useEffect(() => {
    if (initialValues) {
      const { type } = initialValues;

      setActiveTab(type);
    }
  }, [initialValues]);

  const handleCreate = async (data, reset) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isCreated = await SegmentsService.createSegment(data);

      if (isCreated) {
        handleConfirm();
        reset();
        message.success(SUCCESS_CREATE);
      }
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id, reset) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isUpdated = await SegmentsService.updateSegment(id, data);

      if (isUpdated) {
        handleConfirm();
        reset();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleConfirm = () => {
    onSuccess();
    onClose();
  };

  const handleSubmit = (payload, reset) => {
    payload.type = activeTab;

    if (isEditing) {
      handleUpdate(payload, initialValues.id, reset);
    } else {
      handleCreate(payload, reset);
    }
  };

  return (
    <Drawer
      title={initialValues ? 'Редактирование сегмента' : 'Создание сегмента'}
      width="50%"
      onClose={onClose}
      visible={isActive}
    >
      <Tabs
        centered
        activeKey={activeTab}
        onChange={(tab) => setActiveTab(tab)}
      >
        {hiddenTab !== 'by_clients' && (
          <Tabs.TabPane tab="По параметрам" key="general">
            <GeneralForm
              initialValues={initialValues}
              onSubmit={handleSubmit}
            />
          </Tabs.TabPane>
        )}

        {hiddenTab !== 'general' && (
          <Tabs.TabPane tab="По клиентам" key="by_clients">
            <ClientsForm
              initialValues={initialValues}
              onSubmit={handleSubmit}
            />
          </Tabs.TabPane>
        )}
      </Tabs>
    </Drawer>
  );
}

export { SegmentsForm };
